import React from 'react'
const WIN_BADGE = '/static/images/win.svg';

function AmountSection({ auction, postReview = false, }) {
    const {upcoming, status_id} = auction;

    if (postReview) {
        return (
            <div className="item col-xxs-6 clock-container paddingT5">
                Minimum Bid:
                <div className="auction-tile-high-bid paddingT5">
                    {auction?.initial_bid?.formatted}
                </div>
            </div>
        )
    }

    switch (status_id) {
        case '1':
            if (!upcoming) {
                if (auction?.total_bids > 0) {
                    return (
                        <div className="item col-xxs-6 clock-container paddingT5">
                            High Bid:
                            <div className="auction-tile-high-bid paddingT5">
                                {auction?.current_bid?.formatted}
                            </div>
                        </div>
                    );
                }
                return (
                    <div className="item col-xxs-6 clock-container paddingT5">
                        Minimum Bid:
                        <div className="auction-tile-high-bid paddingT5">
                            {auction?.initial_bid?.formatted}
                        </div>
                    </div>
                );
            }
            return (
                <div className="item col-xxs-6 clock-container paddingT5">
                    Minimum Bid:
                    <div className="auction-tile-high-bid paddingT5">
                        {auction?.initial_bid?.formatted}
                    </div>
                </div>
            );
        case '3':
            return (
                <div className="item col-md-12 clock-container paddingT10">
                    Final High Bid:
                    <div className="auction-tile-high-bid paddingT5">
                        $0
                    </div>
                </div>
            );
        case '2':
        case '4':
        case '5':
            return (
                <div className="item col-md-12 clock-container paddingT10">
                    {auction?.user?.is_high_bidder ?
                        <img src={WIN_BADGE} alt="Winner badge" className="winner-badge"/> : ''}
                    Final High Bid:
                    <div className="auction-tile-high-bid paddingT5">
                        {auction?.current_bid?.formatted}
                    </div>
                </div>
            );
        default:
            return null;
    }
}

export default AmountSection
